@for (evidence of evidenceModels() | keyvalue; track evidence.key) {
  <div class="evidence__container">
    <div class="evidence__header">
      Found in:&nbsp;
      <app-anchor-link navigation="" [stopPropagation]="false" (click)="evidenceStepClicked.emit($event)">
        <span appLongTextTooltip class="field-link-value__text">
          {{ evidence.value.stepType | beautifyDisplayString }}
        </span>
      </app-anchor-link>
      &nbsp;{{ evidence.value.location }}
    </div>
    @if (evidence.value.isSensitiveContent) {
      <div class="evidence__description" [innerHtml]="evidence.value.coreEvidence"></div>
      <app-sensitive-message-content
        [id]="evidence.key"
        class="evidence__body"
        [sensitiveDataIndexes]="evidence.value.senstiveDataIndexes"
        [sensitiveDataParams]="evidence.value.sensitiveDataType"
      />
    } @else {
      <div class="evidence__body" [innerHtml]="evidence.value.coreEvidence"></div>
    }
  </div>
}
